import React, { useState } from "react";
import { ChromePicker } from "react-color";
import "../Services/Services.css";
import { useNavigate } from "react-router-dom";

const AboutBannerEdit = () => {
    const navigate = useNavigate();
    const [color, setColor] = useState("#000000");
    const [image, setImage] = useState(null);

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
        }
    };

    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2>Edit Banner</h2>
                <div className="button-group">
                    <button className="saves-btn">Save</button>
                    <button
                        onClick={() => navigate("/aboutus")}
                        className="cancel-btn "
                    >
                        Back
                    </button>
                </div>
            </div>


            <div className="banner-edit-container">

                {/* Heading Input */}
                <div className="aboutus-form-group full-width">
                    <label>
                        Heading <span className="required">*</span>
                    </label>
                    <input type="text" placeholder="Enter your text here..." />
                </div>

                <div className="banner-flex-row">

                    {/* LEFT: Color Picker */}
                    <div className="color-picker-box">
                        <label className="image-label">
                            Profile Image <span style={{ color: "red" }}>*</span>
                        </label>
                        <ChromePicker
                            color={color}
                            onChange={(updatedColor) => setColor(updatedColor.hex)}
                        />
                    </div>

                    {/* RIGHT SIDE: Preview + Upload grouped together */}

                    <div className="banner-right-column">
                        <div
                            className="banner-preview-box"
                            style={{ backgroundColor: color }}
                        >
                            {image ? (
                                <img src={image} alt="Preview" className="banner-preview-image" />
                            ) : null}
                        </div>

                        <div className="upload-btn-wrapper">
                            <label className="upload-btn">
                                ⬆ Upload
                                <input type="file" accept="image/*" onChange={handleImageUpload} />
                            </label>
                        </div>
                    </div>



                </div>
            </div>

        </div>
    );
};

export default AboutBannerEdit;
